module.exports = __webpack_public_path__ + "static/media/avatar.582485a7.jpg";